__turbopack_context__.v({
  "Cont": "Quote-module-sass-module__ySWq3q__Cont",
  "Icons": "Quote-module-sass-module__ySWq3q__Icons",
  "Main": "Quote-module-sass-module__ySWq3q__Main",
  "Quote": "Quote-module-sass-module__ySWq3q__Quote",
});
